import React from 'react';
// import logo from './logo.svg';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
import HomePage from './page/HomePage';
import Layout from './page/layout/Layout';


function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
